// The two top-up pages (Coin Packages, Top Up with Card) are opened from the "Top Up Your
// Wallet" chooser. Their Back button returns to the page the chooser was opened on and opens
// it again, rather than to the retired My Wallet page (client feedback, 21 Oct 2026).
//   chooser link:  <Link to="/credit-packages" state={topUpLinkState(location)}>
//   Back button:   <BackButton to={topUpBackTo(location)} state={{ openTopUp: true }}>
// SiteHeader opens the chooser when it sees `openTopUp` in the router state.
export function topUpLinkState(location) {
    return { topUpFrom: `${location.pathname}${location.search || ""}` }
}

export function topUpBackTo(location) {
    const from = location && location.state && location.state.topUpFrom
    return typeof from === "string" && from.startsWith("/") ? from : "/"
}
